































































































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"
import AlertArea from "../components/AlertArea.vue";

export interface FieldActivity {
  id: number
  correct_state: number
  correct_state_cache: number | null
  score: number
  is_correct_changed: boolean
  is_correct_changed_cache: boolean
  recog_mark_nos: number[]
  recog_mark_nos_1: number[]
  recog_mark_nos_2: number[]
}

export interface Data {
  errors: string[]
  resultDetailFields: any[]
  resultFieldActivities: FieldActivity[]
  isTargetAll: boolean
  isDispCorrectImage: boolean
  resultAreaHeight: number
  colCount: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  props: {
    visible: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    isShowOverlay: {
      type: Boolean,
      default: false,
    },
    fieldActivities: {
      type: Array as PropType<any[]>,
      required: true
    },
    correctImageUrl: {
      type: String,
      default: false,
    },
    correctImageWidth: {
      type: Number,
    },
    correctImageHeight: {
      type: Number,
    },
    windowHeight: {
      type: Number
    },
    isSidebarVisible: {
      type: Boolean
    },
    recog_correct_text: {
      type: String
    },
    isDispStudentInfo: {
      type: Boolean
    },
    correct_mark_nos_text: {
      type: String
    },
    mark_count: {
      type: Number
    },
    sortKind: {
      type: Number
    },
  },
  setup (props, context) {

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      errors: [],
      resultDetailFields: [
        {key: "no", label: "No", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "cut_image", label: "切出し画像", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "recog_mark_nos", label: "認識結果", sortable: true, class: 'text-left b-table-th-td', thStyle: {"vertical-align": "middle", "text-align": "center !important", "white-space": "nowrap"}},
        {key: "correct_state", label: "正誤", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "120px"}},
      ],
      resultFieldActivities: [],
      isTargetAll: true,
      isDispCorrectImage: true,
      resultAreaHeight: 0,
      colCount: context.root.$store.state.markRecogResultColCount,
    });

    const RecogTypeEnum = Common.RecogTypeEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;
    const SortKindEnum = Common.SaitenInputSortKindEnum;

    /************************************************************
     * 模範解答imgタグのCSS
     ************************************************************/

    const correctImageStyle = computed((): any => {
      const style: any = {};
      // style["width"] = `${props.correctImageWidth}px`;
      // style["height"] = `${props.correctImageHeight}px`;
      style["margin-top"] = `8px`;
      style["padding-left"] = `8px`;
      style["padding-right"] = `8px`;
      style["padding-bottom"] = `8px`;
      return style;
    });

    /************************************************************
     * 認識結果エリアの高さ設定
     ************************************************************/

    const setResultAreaHeight = () => {
      let resultAreaHeight = 0;
      const tabBorder = document.getElementById("mark-recog-title-border");
      const header = document.getElementsByClassName("b-sidebar-header");
      
      if(tabBorder && header.length > 0){
        resultAreaHeight = props.windowHeight - tabBorder.offsetTop - header[0].clientHeight - 16;
        console.log(`props.windowHeight:${props.windowHeight}px, tabBorder.offsetTop:${tabBorder.offsetTop}px, header[0].clientHeight:${header[0].clientHeight}px`);
      }
      state.resultAreaHeight = resultAreaHeight;
    }

    watch(() => props.windowHeight, async (newVal, oldVal) => {
      context.root.$nextTick(() => {
        setResultAreaHeight();
      });
    });

    watch(() => state.isDispCorrectImage, async (newVal, oldVal) => {
      context.root.$nextTick(() => {
        setResultAreaHeight();
      });
    });

    watch(() => props.isSidebarVisible, async (newVal, oldVal) => {
      context.root.$nextTick(() => {
        setResultAreaHeight();
      });
    });

    /************************************************************
     * サイドバーClose
     ************************************************************/

    const hiddenSidebar = () => {
      context.emit("hidden");
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      if(context.root.$store.getters.isCompareFinal){
        state.resultDetailFields.splice(3, 0, {key: "recog_mark_nos_1", label: "A採点", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},);
        state.resultDetailFields.splice(4, 0, {key: "recog_mark_nos_2", label: "B採点", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},);
      }
    });


    const recogMarkNosChanged = (field_activity_id: number, recog_mark_nos: number[]) => {
      context.emit("recog-mark-nos-changed", field_activity_id, recog_mark_nos);
    }

    const changeSortKind = (sortKind: number) => {
      context.emit("change-sort-kind", sortKind);
    }

    const changeColCount = (addCount: number) => {
      const colCount = Number(state.colCount) + addCount;
      if(colCount < 1){
        return;
      }
      state.colCount = colCount;
      context.root.$store.commit("setMarkRecogResulttColCount", state.colCount);
    }

    return {
      ...toRefs(state),
      RecogTypeEnum,
      CorrectStateEnum,
      SortKindEnum,
      correctImageStyle,
      hiddenSidebar,
      recogMarkNosChanged,
      changeSortKind,
      changeColCount,
    }
  }
});
